























import { defineComponent, watch } from '@nuxtjs/composition-api';
import { SfInput } from '@storefront-ui/vue';
import { ref } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'QuantitySelector',
  components: {
    SfInput
  },
  props: {
    name: {
      type: String,
      default: 'quantity'
    },
    handleInput: {
      type: Function,
      default: () => {}
    },
    inputValue: {
      type: String,
      default: ''
    },
    isValid: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    maxValue: {
      type: Number,
      default: 9999
    },
    minValue: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: '0'
    },
    label: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const classes = ref([]);
    const isDefault = ref(true);
    const modelValue = ref(props.inputValue);
    watch(
      () => props.inputValue,
      (newVal) => (modelValue.value = newVal)
    );
    return {
      classes,
      isDefault,
      modelValue,
      handleHover: () => {
        classes.value.push('hover');
      },
      handleUnhover: () => {
        classes.value.splice(classes.value.indexOf('hover'), 1);
      },
      handleUpdate: (value) => {
        emit('update', value);
      }
    };
  }
});
